import React from "react";
import { useAccountToDisplaySelector } from "../../redux/actions/user";
import { tt } from "../../utils/i18n/i18n";
import KC_Heading2 from "../../designsystem/typography/KC-Heading/KC_Heading2";
import KC_Heading3 from "../../designsystem/typography/KC-Heading/KC_Heading3";
import BusinessUserForm from "./components/BusinessUserForm";
import ShippingAddressVerticalForm from "./components/ShippingAddressVerticalForm";
import SubscriptionsTable from "./components/SubscriptionsTable";
import AverageBasketForm from "./components/AverageBasketForm";
import PaymentCards from "./components/cards/PaymentCards";
import { LanguageSelector } from "../../components/LanguageSelector/LanguageSelector";
import { ManagedAccountDropdown } from "../../components/ManagedAccountDropdown/ManagedAccountDropdown";

export const BusinessProfile = () => {
  const { accountToDisplay } = useAccountToDisplaySelector();

  return (
    <div
      id="business-profile-page"
      className="d-flex flex-column dashboard-v2 page-padding-standard"
      style={{
        overflowY: "scroll",
        maxHeight: "100%"
      }}
    >
      <div className="d-flex flex-column mb-4">
        <ManagedAccountDropdown />
      </div>
      <div className="d-flex flex-column">
        <div className="d-flex flex-row align-items-center">
          <KC_Heading2 text={tt("my_account")} />
          <div className="flex-grow-1">&nbsp;</div>
          <div className="ml-2">
            <LanguageSelector />
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12 col-sm-4 mt-0 d-flex">
            <div className="card w-100" id="billing-info-card">
              <div className="card-body d-flex flex-column st-gap">
                <KC_Heading3 text={tt("business_profile_billing_info")} />
                <BusinessUserForm customer={accountToDisplay?.businessUser} />
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-4 mt-4 mt-sm-0 d-flex">
            <div className="card w-100" id="shipping-info-card">
              <div className="card-body d-flex flex-column st-gap">
                <KC_Heading3 text={tt("business_profile_shipping_info")} />
                <ShippingAddressVerticalForm
                  customer={accountToDisplay?.businessUser}
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-4 mt-4 mt-sm-0 d-flex">
            <div className="card w-100" id="avg-basket-card">
              <div className="card-body d-flex flex-column st-gap">
                <KC_Heading3 text={tt("business_profile_zone3")} />
                <AverageBasketForm customer={accountToDisplay?.businessUser} />
              </div>
            </div>
          </div>
        </div>

        {!accountToDisplay?.businessUser?.isSaasFreeLicense && (
          <>
            <div className="row mt-4">
              <div className="col-12">
                <div className="card" id="subscriptions-card">
                  <div className="card-body">
                    <h5 className="card-title">
                      {tt("business_profile_active_subscriptions")}
                    </h5>
                    <div>
                      <SubscriptionsTable />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-12">
                <div className="card" id="payment-cards">
                  <div className="card-body">
                    <h5 className="card-title">{tt("means_of_payment")}</h5>
                    <div>
                      <PaymentCards />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
